export const EDI_SAMPLE = {
    source: `ISA*00*          *00*          *ZZ*ACME_CORP      *ZZ*SUPPLIER01     *250315*1030*^*00501*000000001*0*P*>~
GS*PO*ACME_CORP*SUPPLIER01*20250315*1030*1*X*005010~
ST*850*0001~
BEG*00*SA*PO-2025-0042**20250315~
N1*ST*Chicago Distribution Center*92*CDC-01~
N3*100 Industrial Blvd~
N4*Chicago*IL*60601~
PO1*1*50*EA*12.50**VP*BEARING-SET*BP*SKU-A100~
PID*F****Industrial Bearing Set~
PO1*2*200*EA*0.45**VP*HEX-BOLT-M8*BP*SKU-B200~
PID*F****Hex Bolt M8~
CTT*2~
SE*11*0001~
GE*1*1~
IEA*1*000000001`,

    target: `ISA*00*          *00*          *ZZ*ACME_CORP      *ZZ*SUPPLIER01     *250315*1030*^*00501*000000001*0*P*>~
GS*PO*ACME_CORP*SUPPLIER01*20250315*1030*1*X*005010~
ST*850*0001~
BEG*00*SA*PO-2025-0042**20250315~
N1*ST*Chicago Distribution Center*92*CDC-01~
N3*100 Industrial Blvd~
N4*Chicago*IL*60601~
PO1*1*50*EA*13.75**VP*BEARING-SET*BP*SKU-A100~
PID*F****Industrial Bearing Set~
PO1*2*200*EA*0.45**VP*HEX-BOLT-M8*BP*SKU-B200~
PID*F****Hex Bolt M8~
PO1*3*10*BX*24.99**VP*GREASE-TUBE*BP*SKU-C300~
PID*F****Multi-Purpose Grease~
CTT*3~
SE*13*0001~
GE*1*1~
IEA*1*000000001`,
};

export const JSON_SAMPLE = {
    source: JSON.stringify({
        orderId: "ORD-2025-0042",
        customerId: "CUST-001",
        orderDate: "2025-03-15",
        currency: "USD",
        lineItems: [
            {
                lineNumber: 1,
                productCode: "SKU-A100",
                description: "Industrial Bearing Set",
                quantity: 50,
                unitPrice: "12.50",
                uom: "EA",
            },
            {
                lineNumber: 2,
                productCode: "SKU-B200",
                description: "Hex Bolt M8",
                quantity: 200,
                unitPrice: "0.45",
                uom: "EA",
            },
        ],
        shipTo: {
            name: "Main Warehouse",
            city: "Chicago",
            state: "IL",
            zip: "60601",
        },
    }, null, 2),

    target: JSON.stringify({
        orderId: "ORD-2025-0042",
        customerId: "CUST-001",
        orderDate: "2025-03-15",
        currency: "USD",
        lineItems: [
            {
                lineNumber: 1,
                productCode: "SKU-A100",
                description: "Industrial Bearing Set",
                quantity: 50,
                unit_price: 12.50,
                uom: "EA",
            },
            {
                lineNumber: 2,
                productCode: "SKU-B200",
                description: "Hex Bolt M8",
                quantity: 200,
                unit_price: 0.45,
                uom: "EA",
            },
        ],
        shipTo: {
            name: "Main Warehouse",
            city: "Chicago",
            state: "IL",
            zip: "60601",
        },
        carrier: "UPS_GROUND",
    }, null, 2),
};
